<template>
    <div :id="`voiceMessagePlayer`" class="sc-message--text" ref="voiceMessage">
        <span v-if="isGroupMessage" class="whatsapp-number-first" @click.stop="showWhatsappChatStarterModal = true">
            <a href="javascript:void(0)" :style="{ color: getWhatsappNumberColor() }"
                >{{ whatsappAuthorName }} - {{ whatsappAuthorNumber }}</a
            >
        </span>
        <div
            class="audio-player-container voice-message-gallery-host"
            @mouseenter="voiceGalleryHovered = true"
            @mouseleave="voiceGalleryHovered = false"
        >
            <div @click="toggleAudio()">
                <md-icon id="playButton">{{ paused ? "play_circle" : "pause_circle" }}</md-icon>
            </div>
            <av-waveform
                id="waveform"
                :playtime="false"
                :playtimeWithMs="false"
                :playtimeTextBottom="false"
                :playtimeSliderWidth="3"
                :noplayedLineColor="'#999999'"
                :played-line-color="'#6098ff'"
                :audio-src="getSrc()"
                :playtimeFontSize="0"
                :canvWidth="200"
                :canvHeight="40"
                :played-line-width="0.3"
                :noplayed-line-width="0.3"
                :playtime-slider-color="'#4E8CFF'"
            ></av-waveform>
            <button
                v-if="voiceGalleryHovered && chatMessage"
                type="button"
                class="voice-gallery-open-btn"
                v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                :content="$t('chatbotv2.imageView')"
                @click.stop.prevent="$emit('open-gallery', chatMessage)"
            >
                <span class="material-icons">collections</span>
            </button>
        </div>

        <!-- Transkripsiyon Bölümü -->
        <div v-if="data.transcribedText" class="transcription-container">
            <div class="transcription-header" @click="toggleTranscription">
                <span>{{ showTranscription ? "Transkripsiyonu Gizle" : "Transkripsiyonu Göster" }}</span>
                <md-icon>{{ showTranscription ? "expand_less" : "expand_more" }}</md-icon>
            </div>
            <div v-show="showTranscription" class="transcription-text">
                {{ data.transcribedText }}
            </div>
        </div>

        <div v-else class="transcribe-button" @click="requestTranscription">
            <a href="#">{{ $t("table.requestVoiceTranscription") }}</a>
        </div>

        <div
            v-if="isGroupMessage"
            style="display: flex; flex-direction: row; justify-content: end; align-items: center; padding: 0 0.3rem"
        >
            <span class="sc-message-meta-new whatsapp-number" @click.stop="showWhatsappChatStarterModal = true">
                <a href="javascript:void(0)" :style="{ color: getWhatsappNumberColor() }"
                    >{{ whatsappAuthorName }} - {{ whatsappAuthorNumber }}</a
                >
            </span>
        </div>

        <Modal2
            v-if="showWhatsappChatStarterModal"
            @cancel="showWhatsappChatStarterModal = false"
            :title="$t('message.whatsappChatStart')"
            :showFooter="false"
        >
            <WhatsappChatStarter
                :default-phone-number="whatsappAuthorNumber"
                channel-override
                phone-number-override
                @close="showWhatsappChatStarterModal = false"
                :default-name="whatsappAuthorName"
            />
        </Modal2>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { sendSocketMessage } from "../../../utils/socketStream";
import _ from "lodash";
import Modal2 from "../../common/Modal2.vue";
import WhatsappChatStarter from "../../../views/Pages/Integrations/meta-leads/WhatsappChatStarter.vue";
import StringUtils from "../../../utils/StringUtils";

export default {
    name: "VoiceMessage",
    props: {
        data: {
            type: Object,
            required: true,
        },
        chatMessage: {
            type: Object,
            default: null,
        },
    },
    data: function () {
        return {
            paused: true,
            showTranscription: false,
            showWhatsappChatStarterModal: false,
            voiceGalleryHovered: false,
        };
    },
    computed: {
        ...mapState({
            isDarkMod: (state) => state.app.darkMode,
            siteId: (state) => state.site.site._id,
        }),
        isGroupMessage() {
            return !!_.get(this.data, "whatsappAuthor.author");
        },
        whatsappAuthorNumber() {
            return _.get(this.data, "whatsappAuthor.author", "").replace(/[^0-9]/g, "");
        },
        whatsappAuthorName() {
            return _.get(this.data, "whatsappAuthor.authorName", "");
        },
    },
    methods: {
        getSrc() {
            const asset = this.data.asset;
            const path = asset?.path || "";
            if (path === "") return null;
            const isWhatsapp = path.indexOf("whatsapp") !== -1;
            const isInstagram = path.indexOf("instagram") !== -1;
            const isMessenger = path.indexOf("messenger") !== -1;
            const isTelegram = path.indexOf("telegram") !== -1;
            const isFacebook = path.indexOf("facebook") !== -1;
            const isTable = path.indexOf("tables/attachments") !== -1;
            const isUnipile = path.indexOf("unipile") !== -1;
            const isChat = path.indexOf("chat") !== -1;
            const isApiMessages = path.indexOf("api-messages") !== -1;
            const src =
                isWhatsapp || isInstagram || isTelegram || isMessenger || isFacebook || isTable || isUnipile || isChat || isApiMessages
                    ? `https://static.supsis.live/${asset.path}`
                    : asset.v2Format && asset.cdnUrl
                    ? asset.cdnUrl
                    : `https://static.supsis.live/${asset.path + asset._id}${asset.ext ? "." + asset.ext : ""}`;
            return src;
        },
        toggleAudio() {
            const audio = this.$refs.voiceMessage.querySelector(`audio`);
            audio[audio?.paused ? "play" : "pause"]();
            this.paused = !this.paused;
        },
        toggleTranscription() {
            this.showTranscription = !this.showTranscription;
        },
        requestTranscription() {
            const conversationId =
                (typeof this.data.conversation === "object" ? this.data.conversation._id : this.data.conversation) ||
                this.data.conversationId;
            sendSocketMessage("user transcribe-audio", {
                siteId: this.siteId,
                conversationId: conversationId,
                uniqMessageId: this.data.uniqMessageId,
                cdnUrl: this.data.asset.cdnUrl,
            });
        },
        getWhatsappNumberColor() {
            if (this.isGroupMessage) {
                const colors = ["#1a5fb4", "#813d9c", "#c64600", "#2ec27e", "#e01b24", "#3584e4", "#9141ac", "#f5c211"];
                const index = Math.abs(this.hashCode(this.whatsappAuthorNumber)) % colors.length;
                return colors[index];
            }
            return "#4e8cff";
        },
        hashCode(str) {
            let hash = 0;
            for (let i = 0; i < str.length; i++) {
                const char = str.charCodeAt(i);
                hash = (hash << 5) - hash + char;
                hash = hash & hash; // Convert to 32bit integer
            }
            return hash;
        },
    },
    watch: {
        data: {
            deep: true,
            handler(newVal) {
                console.log("audio data changed", newVal);
            },
        },
    },
    components: {
        Modal2,
        WhatsappChatStarter,
    },
};
</script>

<style lang="scss" scoped>
#voiceMessagePlayer {
    display: flex;
    flex-direction: column;
    padding: 4px;
    background-color: transparent;

    &::after {
        display: none;
    }
}

.voice-message-gallery-host {
    position: relative;
}

.voice-gallery-open-btn {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 2;
    background: rgba(0, 0, 0, 0.45);
    border: none;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background 0.2s;

    .material-icons {
        color: #fff;
        font-size: 17px;
    }

    &:hover {
        background: rgba(0, 0, 0, 0.75);
    }
}

.audio-player-container {
    display: flex;
    align-items: center;
    margin-bottom: 8px;

    i.md-icon {
        font-style: normal !important;
        background-color: none !important;
        padding: 0 !important;
        margin-right: 4px;
        color: #4e8cff;
    }
}

#waveform {
    margin-right: 20px;
    padding: 0 10px 0 20px;
    background-color: #ededed;
    border-radius: 25px;
}

.sc-message--text {
    background-color: transparent;
}

.transcription-container {
    margin-top: 4px;
    width: 100%;
    padding-left: 28px;
}

.transcription-header {
    display: flex;
    align-items: center;
    cursor: pointer;
    color: #666;
    font-size: 0.9em;

    .md-icon {
        font-size: 20px;
        margin-left: 4px;
    }
}

.transcription-text {
    margin-top: 8px;
    padding: 8px;
    background-color: #f5f5f5;
    border-left: 3px solid #ddd;
    color: #666;
    font-size: 0.9em;
    border-radius: 4px;
}

.transcribe-button {
    margin-top: 4px;
    padding-left: 28px;

    a {
        color: #4e8cff;
        text-decoration: none;
        font-size: 0.9em;

        &:hover {
            text-decoration: underline;
        }
    }
}

.whatsapp-number {
    cursor: pointer;

    a {
        text-decoration: underline;
    }
}

.whatsapp-number-first {
    cursor: pointer;
    font-size: smaller;
    font-weight: 200;
    letter-spacing: 2px;

    a {
        &:hover {
            text-decoration: underline;
        }
    }

    padding: 5px;
}

.sc-message-meta-new {
    font-size: 8px;
    font-weight: 300;
    color: white;
    text-align: right;
    border-radius: 6px;
    text-transform: uppercase;
    white-space: nowrap;
    text-overflow: ellipsis;
    line-height: 0px !important;
    margin: 5px !important;
    margin-right: 14px !important;
    margin-bottom: 14px !important;
}
</style>
